/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLiveClientRequestBody
 */
export interface CreateLiveClientRequestBody {
    /**
     * 
     * @type {string}
     * @memberof CreateLiveClientRequestBody
     */
    ip: string;
}

/**
 * Check if a given object implements the CreateLiveClientRequestBody interface.
 */
export function instanceOfCreateLiveClientRequestBody(value: object): value is CreateLiveClientRequestBody {
    if (!('ip' in value) || value['ip'] === undefined) return false;
    return true;
}

export function CreateLiveClientRequestBodyFromJSON(json: any): CreateLiveClientRequestBody {
    return CreateLiveClientRequestBodyFromJSONTyped(json, false);
}

export function CreateLiveClientRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLiveClientRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'ip': json['ip'],
    };
}

export function CreateLiveClientRequestBodyToJSON(json: any): CreateLiveClientRequestBody {
    return CreateLiveClientRequestBodyToJSONTyped(json, false);
}

export function CreateLiveClientRequestBodyToJSONTyped(value?: CreateLiveClientRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ip': value['ip'],
    };
}

